'use es6';

import PropTypes from 'prop-types';
import { OUTAGE_REASONS } from '../constants/outageReasons.constants';
const OutageReasonPropType = PropTypes.oneOf([OUTAGE_REASONS.UNPLANNED_OUTAGE, OUTAGE_REASONS.PLANNED_OUTAGE]);
export default OutageReasonPropType;